"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartSummaryView = void 0;
const React = require("react");
const react_1 = require("react");
const SalesOrderContext_1 = require("../../contexts/SalesOrderContext");
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
const Loader_1 = require("../../../../../components/base/atoms/Loader");
const CartSummaryHeader_1 = require("./CartSummaryHeader");
const CartSummaryItems_1 = require("./CartSummaryItems");
const CartSummaryDetails_1 = require("./CartSummaryDetails");
const CartSummaryNotes_1 = require("./CartSummaryNotes");
const CartSummaryFooter_1 = require("./CartSummaryFooter");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "CartSummaryView");
const CartSummaryView = ({}) => {
    const { retailLocation } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    const { isUpdatingCart } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    const [checkingRestaurantServiceAvailability, setCheckingRestaurantServiceAvailability] = (0, react_1.useState)(false);
    const isLoading = (0, react_1.useMemo)(() => isUpdatingCart || checkingRestaurantServiceAvailability, [isUpdatingCart, checkingRestaurantServiceAvailability]);
    const loadingMsg = (0, react_1.useMemo)(() => isUpdatingCart ? "updating cart..." : "checking service availability", [isUpdatingCart]);
    if (!retailLocation) {
        return null;
    }
    return (React.createElement("div", { className: css("") },
        React.createElement(Loader_1.LoadingOverlay, { className: css("loader"), text: loadingMsg, visible: isLoading },
            React.createElement(CartSummaryHeader_1.CartSummaryHeader, null),
            React.createElement("div", { className: css("body") },
                React.createElement("div", { className: css("body_inner") },
                    React.createElement(CartSummaryDetails_1.CartSummaryDetails, { setCheckingRestaurantServiceAvailability: setCheckingRestaurantServiceAvailability }),
                    React.createElement(CartSummaryNotes_1.CartSummaryNotes, null),
                    React.createElement(CartSummaryItems_1.CartSummaryItems, null))),
            React.createElement(CartSummaryFooter_1.CartSummaryFooter, null))));
};
exports.CartSummaryView = CartSummaryView;
//# sourceMappingURL=index.js.map